import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import styles from "./testimonials.module.css"

const Testimonial = ({ image, quote, name, position }) => (
  <figure className={styles.testimonial}>
    <Img
      fixed={image}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "50% 50%",
      }}
    />
    <figcaption>
      <blockquote>
        <p>{quote}</p>
        <dl>
          <dt>{name}</dt>
          <dd>{position}</dd>
        </dl>
      </blockquote>
    </figcaption>
  </figure>
)

const Testimonials = ({ first = "camila", second = "leticia" }) => {
  const data = useStaticQuery(graphql`
    query {
      leticia: file(relativePath: { eq: "testimonials/leticia.jpg" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      andre: file(relativePath: { eq: "testimonials/andre.png" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      camila: file(relativePath: { eq: "testimonials/camila.jpg" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      guilherme: file(relativePath: { eq: "testimonials/guilherme.jpg" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  const text = {
    camila: {
      image: data.camila.childImageSharp.fixed,
      quote: `“A Facio apareceu no momento em que eu mais precisava. Sem burocracia,
      mas não deixando de ser transparente em todo o processo. Me ajudou
      dentro das minhas possibilidades e por isso sou muito grata!!”`,
      name: `Camila`,
      position: `Colaboradora Sumup`,
    },
    leticia: {
      image: data.leticia.childImageSharp.fixed,
      quote: `“A Facio ajudou a Sumup a melhorar a vida financeira dos
      funcionários. Diminuímos o endividamento de boa parte da
      equipe e agora eles trabalham de maneira mais tranquila
      e produtiva.”`,
      name: `Letícia Faria`,
      position: `Global VP People SumUp`,
    },
    andre: {
      image: data.andre.childImageSharp.fixed,
      quote: `“Procurávamos um serviço que realmente tivesse efeito
      positivo na vida financeira dos nossos funcionários e a
      Facio estava disposta a fazer isso de uma forma
      totalmente inovadora.”`,
      name: `André Cerciari`,
      position: `People Operations Sumup`,
    },
    guilherme: {
      image: data.guilherme.childImageSharp.fixed,
      quote: `“Um benefício prático para aqueles momentos em que precisamos de uma ajudinha financeira. O aplicativo deixa claro o que você está pagando de juros, o que o torna uma ótima alternativa àquele modelo antigo que muitos bancos seguem à risca. Simplesmente genial!”`,
      name: `Guilherme`,
      position: `Colaborador Sumup`,
    },
  }
  return (
    <section className={styles.testimonialGroup}>
      <div className="wrapper">
        <h2>O que estão falando da Facio</h2>
        <ul className={styles.testimonials}>
          <li>
            <Testimonial
              image={text[first].image}
              quote={text[first].quote}
              name={text[first].name}
              position={text[first].position}
            />
          </li>
          <li>
            <Testimonial
              image={text[second].image}
              quote={text[second].quote}
              name={text[second].name}
              position={text[second].position}
            />
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Testimonials
